import React from "react";
import TaxCard from "../modules/Fees/TaxesModule/TaxCard";

export function TaxCardPage (props) {
  return (
    <TaxCard {...props} />
  );
}
